<template>
    <div class="footer">
        <div>
            <img src="../assets/img/footer_logo.png" class="l_logo">
            <p>Copyright © 2020 iTrust.cn .ALL Rights Reserved</p>
            <p>
                <a rel="nofollow" href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备20006130号-3</a>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002003137"  rel="nofollow">
                    川公网安备 51019002003137号 <img src="https://www.knowsafe.com/img/beian_ga.png" style="vertical-align: middle"/>
                </a>
            </p>
            <a href="https://v.itrust.cn/?safetykeyid=9273c88985aaee2970fd551e29778183" target="_blank" class="cert"><img src="https://www.knowsafe.com/img/cert.svg"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mfooter"
    }
</script>

<style scoped>
    .footer{ height: 120px; color: #9aabb8; font-size: 12px}
    .footer>div{ width: 1000px; margin: 0 auto; position: relative; padding-left: 100px; padding-top: 44px}
    .footer>div .l_logo{ position: absolute; left: 0; top: 50px}
    .footer a{color: #9aabb8; text-decoration: none}
    .footer .cert{ position: absolute; right: 0; top: 43px}
    .footer .cert img{ height: 47px}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue